"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _init = require("./actions/init");

var _setView = require("./actions/set-view");

var _toggleInbox = require("./actions/toggle-inbox");

var _markAllRead = require("./actions/mark-all-read");

var _newMessage = require("./actions/new-message");

var _unpinMessage = require("./actions/unpin-message");

var _resetLastFetched = require("./actions/reset-last-fetched");

var _markMessageArchived = require("./actions/mark-message-archived");

var _markMessageRead = require("./actions/mark-message-read");

var _markMessageOpened = require("./actions/mark-message-opened");

var _markMessageUnread = require("./actions/mark-message-unread");

var _fetchUnreadMessageCount = require("./actions/fetch-unread-message-count");

var _fetchMessages = require("./actions/fetch-messages");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  isOpen: false,
  messages: [],
  view: "messages",
  unreadMessageCount: 0
};
exports.initialState = initialState;

var sortPinned = function sortPinned(pinned, brand) {
  var _brand$inapp, _brand$inapp$slots, _pinnedBySlot$unconfi;

  var configuredSlots = brand === null || brand === void 0 ? void 0 : (_brand$inapp = brand.inapp) === null || _brand$inapp === void 0 ? void 0 : (_brand$inapp$slots = _brand$inapp.slots) === null || _brand$inapp$slots === void 0 ? void 0 : _brand$inapp$slots.map(function (s) {
    return s.id;
  });
  var pinnedBySlot = pinned === null || pinned === void 0 ? void 0 : pinned.reduce(function (acc, curr) {
    var _curr$pinned, _curr$pinned2;

    if (!curr.pinned || !((_curr$pinned = curr.pinned) !== null && _curr$pinned !== void 0 && _curr$pinned.slotId)) {
      return acc;
    }

    if (configuredSlots !== null && configuredSlots !== void 0 && configuredSlots.includes(curr === null || curr === void 0 ? void 0 : (_curr$pinned2 = curr.pinned) === null || _curr$pinned2 === void 0 ? void 0 : _curr$pinned2.slotId)) {
      var _curr$pinned3, _curr$pinned4, _curr$pinned5;

      acc[curr === null || curr === void 0 ? void 0 : (_curr$pinned3 = curr.pinned) === null || _curr$pinned3 === void 0 ? void 0 : _curr$pinned3.slotId] = acc[curr === null || curr === void 0 ? void 0 : (_curr$pinned4 = curr.pinned) === null || _curr$pinned4 === void 0 ? void 0 : _curr$pinned4.slotId] || [];
      acc[curr === null || curr === void 0 ? void 0 : (_curr$pinned5 = curr.pinned) === null || _curr$pinned5 === void 0 ? void 0 : _curr$pinned5.slotId].push(curr);
    } else {
      acc.unconfigured.push(curr);
    }

    return acc;
  }, {
    unconfigured: []
  });
  var mappedPinnedMessages = (configuredSlots !== null && configuredSlots !== void 0 ? configuredSlots : []).map(function (slotId) {
    var _pinnedBySlot$slotId;

    return (_pinnedBySlot$slotId = pinnedBySlot === null || pinnedBySlot === void 0 ? void 0 : pinnedBySlot[slotId]) !== null && _pinnedBySlot$slotId !== void 0 ? _pinnedBySlot$slotId : [];
  }).filter(Boolean).flat();
  return [].concat((0, _toConsumableArray2["default"])(mappedPinnedMessages), (0, _toConsumableArray2["default"])((_pinnedBySlot$unconfi = pinnedBySlot === null || pinnedBySlot === void 0 ? void 0 : pinnedBySlot.unconfigured) !== null && _pinnedBySlot$unconfi !== void 0 ? _pinnedBySlot$unconfi : []));
};

var sortMessages = function sortMessages(a, b) {
  return new Date(b.created).getTime() - new Date(a.created).getTime();
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action === null || action === void 0 ? void 0 : action.type) {
    case _init.INBOX_INIT:
      {
        return _objectSpread(_objectSpread({}, state), action.payload);
      }

    case _setView.INBOX_SET_VIEW:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          view: action.payload
        });
      }

    case _toggleInbox.INBOX_TOGGLE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isOpen: typeof action.payload === "boolean" ? action.payload : !state.isOpen
        });
      }

    case _fetchUnreadMessageCount.INBOX_FETCH_UNREAD_MESSAGE_COUNT_DONE:
      {
        var _action$payload$count, _action$payload;

        return _objectSpread(_objectSpread({}, state), {}, {
          unreadMessageCount: (_action$payload$count = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.count) !== null && _action$payload$count !== void 0 ? _action$payload$count : 0
        });
      }

    case _fetchMessages.INBOX_FETCH_MESSAGES_PENDING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case _fetchMessages.INBOX_FETCH_MESSAGES_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }

    case _resetLastFetched.INBOX_RESET_LAST_FETCHED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          lastMessagesFetched: undefined
        });
      }

    case _fetchMessages.INBOX_FETCH_MESSAGES_DONE:
      {
        var _action$payload2, _state$messages, _action$payload$messa, _action$payload3, _action$payload4, _action$payload5, _action$payload6, _action$payload7;

        var newMessages = (_action$payload2 = action.payload) !== null && _action$payload2 !== void 0 && _action$payload2.appendMessages ? [].concat((0, _toConsumableArray2["default"])((_state$messages = state === null || state === void 0 ? void 0 : state.messages) !== null && _state$messages !== void 0 ? _state$messages : []), (0, _toConsumableArray2["default"])((_action$payload$messa = (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.messages) !== null && _action$payload$messa !== void 0 ? _action$payload$messa : [])) : (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.messages;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          lastMessagesFetched: new Date().getTime(),
          messages: newMessages,
          pinned: (_action$payload5 = action.payload) !== null && _action$payload5 !== void 0 && _action$payload5.appendMessages ? state.pinned : sortPinned((_action$payload6 = action.payload) === null || _action$payload6 === void 0 ? void 0 : _action$payload6.pinned, state.brand),
          startCursor: (_action$payload7 = action.payload) === null || _action$payload7 === void 0 ? void 0 : _action$payload7.startCursor
        });
      }

    case _markMessageRead.INBOX_MARK_MESSAGE_READ:
      {
        var _state$unreadMessageC, _state$pinned, _state$messages2;

        var unreadMessageCount = Math.max(0, ((_state$unreadMessageC = state.unreadMessageCount) !== null && _state$unreadMessageC !== void 0 ? _state$unreadMessageC : 0) - 1);

        var handleMarkRead = function handleMarkRead(message) {
          if (message.messageId === action.payload.messageId) {
            return _objectSpread(_objectSpread({}, message), {}, {
              read: new Date().toISOString()
            });
          }

          return message;
        };

        var newPinned = (_state$pinned = state.pinned) === null || _state$pinned === void 0 ? void 0 : _state$pinned.map(handleMarkRead);

        var _newMessages = (_state$messages2 = state.messages) === null || _state$messages2 === void 0 ? void 0 : _state$messages2.map(handleMarkRead);

        return _objectSpread(_objectSpread({}, state), {}, {
          pinned: newPinned,
          messages: _newMessages,
          unreadMessageCount: unreadMessageCount
        });
      }

    case _markMessageUnread.INBOX_MARK_MESSAGE_UNREAD:
      {
        var _state$unreadMessageC2, _state$pinned2, _state$messages3;

        var _unreadMessageCount = ((_state$unreadMessageC2 = state.unreadMessageCount) !== null && _state$unreadMessageC2 !== void 0 ? _state$unreadMessageC2 : 0) + 1;

        var handleMarkUnread = function handleMarkUnread(message) {
          if (message.messageId !== action.payload.messageId) {
            return message;
          }

          var newMessage = _objectSpread(_objectSpread({}, message), {}, {
            read: undefined
          });

          return newMessage;
        };

        var _newPinned = (_state$pinned2 = state.pinned) === null || _state$pinned2 === void 0 ? void 0 : _state$pinned2.map(handleMarkUnread);

        var _newMessages2 = (_state$messages3 = state.messages) === null || _state$messages3 === void 0 ? void 0 : _state$messages3.map(handleMarkUnread);

        return _objectSpread(_objectSpread({}, state), {}, {
          messages: _newMessages2,
          pinned: _newPinned,
          unreadMessageCount: _unreadMessageCount
        });
      }

    case _markMessageOpened.INBOX_MARK_MESSAGE_OPENED:
      {
        var _state$pinned3, _state$messages4;

        var handleMarkOpened = function handleMarkOpened(message) {
          if (message.messageId === action.payload.messageId) {
            return _objectSpread(_objectSpread({}, message), {}, {
              opened: new Date().toISOString()
            });
          }

          return message;
        };

        var _newPinned2 = (_state$pinned3 = state.pinned) === null || _state$pinned3 === void 0 ? void 0 : _state$pinned3.map(handleMarkOpened);

        var _newMessages3 = (_state$messages4 = state.messages) === null || _state$messages4 === void 0 ? void 0 : _state$messages4.map(handleMarkOpened);

        return _objectSpread(_objectSpread({}, state), {}, {
          messages: _newMessages3,
          pinned: _newPinned2
        });
      }

    case _unpinMessage.INBOX_UNPIN_MESSAGE:
      {
        var _state$pinned4, _state$messages5;

        var pinned = (_state$pinned4 = state.pinned) !== null && _state$pinned4 !== void 0 ? _state$pinned4 : [];
        var messageToUnpin = pinned === null || pinned === void 0 ? void 0 : pinned.find(function (p) {
          return p.messageId === action.payload.messageId;
        });

        if (!messageToUnpin) {
          return state;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          pinned: pinned.filter(function (p) {
            return p.messageId !== action.payload.messageId;
          }),
          messages: [].concat((0, _toConsumableArray2["default"])((_state$messages5 = state.messages) !== null && _state$messages5 !== void 0 ? _state$messages5 : []), [_objectSpread(_objectSpread({}, messageToUnpin), {}, {
            pinned: undefined
          })]).sort(sortMessages)
        });
      }

    case _markMessageArchived.INBOX_MARK_MESSAGE_ARCHIVED:
      {
        var _state$unreadMessageC3, _state$pinned5, _state$messages6;

        var _unreadMessageCount2 = (_state$unreadMessageC3 = state.unreadMessageCount) !== null && _state$unreadMessageC3 !== void 0 ? _state$unreadMessageC3 : 0;

        var handleArchived = function handleArchived(message) {
          var isMatching = message.messageId === action.payload.messageId;

          if (isMatching && !message.read) {
            _unreadMessageCount2 = Math.max(_unreadMessageCount2 - 1, 0);
          }

          return !isMatching;
        };

        var _newPinned3 = (_state$pinned5 = state.pinned) === null || _state$pinned5 === void 0 ? void 0 : _state$pinned5.filter(handleArchived);

        var _newMessages4 = (_state$messages6 = state.messages) === null || _state$messages6 === void 0 ? void 0 : _state$messages6.filter(handleArchived);

        return _objectSpread(_objectSpread({}, state), {}, {
          pinned: _newPinned3,
          messages: _newMessages4,
          unreadMessageCount: _unreadMessageCount2
        });
      }

    case _newMessage.INBOX_NEW_MESSAGE:
      {
        var _newMessage$pinned, _state$unreadMessageC5, _state$messages7;

        var newMessage = _objectSpread(_objectSpread({}, action.payload), {}, {
          created: new Date().toISOString()
        });

        if (newMessage !== null && newMessage !== void 0 && (_newMessage$pinned = newMessage.pinned) !== null && _newMessage$pinned !== void 0 && _newMessage$pinned.slotId) {
          var _state$pinned6, _state$unreadMessageC4;

          var _newPinned4 = sortPinned([newMessage].concat((0, _toConsumableArray2["default"])((_state$pinned6 = state.pinned) !== null && _state$pinned6 !== void 0 ? _state$pinned6 : [])), state.brand);

          return _objectSpread(_objectSpread({}, state), {}, {
            unreadMessageCount: ((_state$unreadMessageC4 = state.unreadMessageCount) !== null && _state$unreadMessageC4 !== void 0 ? _state$unreadMessageC4 : 0) + 1,
            pinned: _newPinned4
          });
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          unreadMessageCount: ((_state$unreadMessageC5 = state.unreadMessageCount) !== null && _state$unreadMessageC5 !== void 0 ? _state$unreadMessageC5 : 0) + 1,
          messages: [newMessage].concat((0, _toConsumableArray2["default"])((_state$messages7 = state.messages) !== null && _state$messages7 !== void 0 ? _state$messages7 : []))
        });
      }

    case _markAllRead.INBOX_MARK_ALL_READ:
      {
        var _state$pinned7, _state$messages8;

        var _unreadMessageCount3 = 0;

        var _handleMarkRead = function _handleMarkRead(message) {
          return _objectSpread(_objectSpread({}, message), {}, {
            read: new Date().toISOString()
          });
        };

        var _newPinned5 = (_state$pinned7 = state.pinned) === null || _state$pinned7 === void 0 ? void 0 : _state$pinned7.map(_handleMarkRead);

        var _newMessages5 = (_state$messages8 = state.messages) === null || _state$messages8 === void 0 ? void 0 : _state$messages8.map(_handleMarkRead);

        return _objectSpread(_objectSpread({}, state), {}, {
          lastMarkedAllRead: new Date().getTime(),
          messages: _newMessages5,
          pinned: _newPinned5,
          unreadMessageCount: _unreadMessageCount3
        });
      }
  }

  return state;
};

exports["default"] = _default;